import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const SectionNameCard = ({ sectionName = "", path = "#" }) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="card cursor-pointer section-name-card"
        onClick={() => navigate(path)}
        style={{
          height: "105.33px",
        }}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center h-100">
            <span className="fs14px">{sectionName}</span>
            <IoIosArrowForward fontSize={"30px"} color="#0e2c24" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionNameCard;
